import { IVisaApplicationPdfCopyDocumentsList, VisaApplicationPdfCopyDocMap } from '../../../../../types';
import { getVisible } from '../../../../../utilities/documents';
import Finger, { Status } from '../../../../atoms/finger';
import ChecklistSection from '../../../../atoms/checklist-section';

interface IProps {
  documents: VisaApplicationPdfCopyDocMap;
  openDocumentModal: (
    sponsorType: string,
    sponsorKey: null,
    docType: string,
    docKey: string,
    modalTitle: string,
    fileNames: string[],
    isComplete: boolean,
    biometricResidencePermit?: any
  ) => void;
}

export const VisaApplicationPdfCopyDocs = (props: IProps) => {
  const { documents: docs, openDocumentModal } = props;

  if (!docs || Object.keys(docs).length === 0) {
    return null;
  }
  const visibleDocs = getVisible(docs as any, false) as unknown as IVisaApplicationPdfCopyDocumentsList[];

  if (visibleDocs.length === 0) {
    return null;
  }

  let isComplete = false;
  let fileNames: string[] = [];
  let docKey = '';

  const openModal = (modalTitle: string) => {
    openDocumentModal('beforeTravel', null, 'visaApplicationPdfCopy', docKey, modalTitle, fileNames, isComplete);
  };

  const renderedDocs = visibleDocs.map(({ item, key: visaVignetteKey }) => {
    docKey = visaVignetteKey;

    switch (item.status) {
      case 'REJECTED': {
        return (
          <Finger
            key={`visa-application-pdf-copy-${visaVignetteKey}`}
            id={`visa-application-pdf-copy-${visaVignetteKey}`}
            hideButton={true}
            status={Status.Rejected}
            reason={item.reason}
            label={`Visa Application PDF Copy`}
          />
        );
      }
      case 'APPROVED':
      case 'UPLOADED_OK':
      case 'REPLACED': {
        isComplete = true;
        fileNames = item.fileNames;
        docKey = visaVignetteKey;

        return (
          <Finger
            key={`visa-application-pdf-copy-${visaVignetteKey}`}
            id={`visa-application-pdf-copy-${visaVignetteKey}`}
            status={Status.Complete}
            completeLabel={'Done'}
            label={`Visa Application PDF Copy`}
            onClick={() => {
              openModal(`Visa Application PDF Copy`);
            }}
          />
        );
      }
      default: {
        docKey = visaVignetteKey;
        return (
          <Finger
            key={`visa-application-pdf-copy-${visaVignetteKey}`}
            id={`visa-application-pdf-copy-${visaVignetteKey}`}
            status={Status.InProgress}
            completeLabel={'Done'}
            label={`Visa Application PDF Copy`}
            onClick={() => {
              openModal(`Visa Application PDF Copy`);
            }}
          />
        );
      }
    }
  });

  return (
    <>
      <ChecklistSection label={`Upload the visa application PDF sent to you from UKVI`}>
        {renderedDocs}
      </ChecklistSection>
    </>
  );
};
